export default "__VITE_ASSET__CXHOE$yC__"